<script setup lang="ts">
const { opened, contentRef } = await useInvitationPage();
const floatingButtonRef = useTemplateRef("floatingButton");

watch(
  () => opened.value,
  (value) => {
    if (value && import.meta.client) {
      document.documentElement.style.overflow = "";
      floatingButtonRef.value?.onToggleMusic();

      setTimeout(() => {
        contentRef.value?.focus();
      }, 500);
    }
  },
);
</script>

<template>
  <div>
    <ClientOnly>
      <LazyUiTransitionsInvitationCover>
        <POpeningCard
          v-if="!opened"
          @open="opened = true"
        />
      </LazyUiTransitionsInvitationCover>

      <NuxtLayout
        :opened="opened"
      >
        <LazyUiTransitionsInvitationMain>
          <div
            ref="contentRef"
            tabindex="-1"
            class="h-safe-min-screen"
          >
            <LazyPHero
              :opened="opened"
            />

            <template
              v-if="opened"
            >
              <LazyVisiblePEvents
                hydrate-on-visible
              />
              <LazyVisiblePEventsCountdown
                hydrate-on-visible
              />
              <LazyVisiblePLocation
                hydrate-on-visible
              />
              <LazyVisiblePGallery
                hydrate-on-visible
              />
              <LazyVisiblePGroupRsvpDcGift
                hydrate-on-visible
              />
              <LazyVisiblePWishes
                hydrate-on-visible
              />
            </template>

            <div
              v-show="opened"
            >
              <LazyPFloatingButton
                ref="floatingButton"
                :opened="opened"
              />
            </div>
          </div>
        </LazyUiTransitionsInvitationMain>
      </NuxtLayout>
    </ClientOnly>
  </div>
</template>
